<template>
  <auth-shell>
    <div v-if="accountLogo" class="auth-logo">
      <img :src="accountLogo" :class="{ 'account-logo': !isCustomDomain }"/>
    </div>
    <h4 class="auth-title">Reset Your Password</h4>
    <p class="auth-subtitle">
      Enter your email and we'll send you a link to reset your password.
    </p>
    <div class="form-group">
      <label class="auth-label">Your Email</label>
      <input
          type="text"
          name="Username"
          class="auth-field"
          placeholder="Your Email"
          v-model="email"
          v-on:keyup.enter="ResetPassword()"
      />
    </div>
    <button
        v-on:click="ResetPassword()"
        class="auth-btn-primary mt-2"
    >
      <b-spinner
          variant="light"
          v-show="working"
          type="grow"
          small
      ></b-spinner>
      Send Password Reset Link
    </button>
    <div v-if="locked" class="auth-success-note">
      <svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0; margin-top: 1px;">
        <path d="M4 10.5L8.5 15L16 5.5" stroke="#019256" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Reset link sent. Check your email for the link to reset your password.
    </div>
    <a href="/" class="auth-btn-ghost mt-3">Login Instead</a>
  </auth-shell>
</template>

<script>
import { getAccountLogo, isCustomDomain } from "../utils/helpers";
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
  data() {
    return {
      email: "",
      working: false,
      locked: false,
      isCustomDomain
    };
  },
  methods: {
    inputValid: function (val) {
      return val ? "has-success" : "has-error";
    },
    allFormElementsValid: function () {
      return this.passwordValid && this.passwordMatch;
    },
    async ResetPassword() {
      if (this.locked) {
        return;
      }
      if (this.email == "") {
        this.$A.AlertUser("Please enter your email", "warning");
        return;
      }

      this.working = true;
      let body = await this.$A.UserService.SendResetPasswordLink(this.email);
      this.working = false;
      if (body && body.success) {
        this.locked = true;
      }
    },
  },
  computed: {
    accountLogo: function () {
      return getAccountLogo();
    }
  }
};
</script>

<style scoped>
.account-logo {
  width: 50px;
  height: 50px;
}
</style>
